module.exports = __webpack_public_path__ + "static/img/cashier-new-order.7828b8ae.svg";